import { render, staticRenderFns } from "./edit-customer.vue?vue&type=template&id=d8f9fb84"
import script from "./edit-customer.vue?vue&type=script&lang=ts"
export * from "./edit-customer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports